"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_call(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8d275f65-265e-45da-b04a-da2333ad1c43",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "main_icn_Landline_or_Call"), /*#__PURE__*/React.createElement("path", {
    id: "f6e1c40a-76e9-4626-ab71-b616b443e8dd",
    "data-name": "<Pfad>",
    d: "M115.81,129.17l12.85-9.7c3.39-1.74,6.88-2.16,9-.87,3.19,2,30,19.88,32.23,21.47s3.29,6.09.13,10.47S152.33,172.23,146.25,172s-31.39-1-78.61-48.47S20.13,51,20,45,37.62,24.88,42.1,21.84s9-1.86,10.59.31c1.77,2.47,19.22,29.17,21.14,32.23,1.31,2.09.79,5.56-1,8.88s-9.33,16-9.33,16S68.58,88.13,86,105.67C94.3,114.17,115.81,129.17,115.81,129.17Z",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_call;
exports.default = _default;